import React from "react"

import { ProjectChild } from "shared/types/Project"

import { CopyProjectChildrenOverlay } from "./CopyProjectChildrenOverlay"
import { useCopyProjectChildrenOverlayModel } from "./hooks/useCopyProjectChildrenOverlayModel"

export interface CopyProjectChildrenOverlayPayload {
  projectID: string
  projectChildren: ProjectChild[]
}

export interface CopyProjectChildrenOverlayConnectorProps {
  payload: CopyProjectChildrenOverlayPayload
}

export const CopyProjectChildrenOverlayConnector = React.memo(
  (props: CopyProjectChildrenOverlayConnectorProps) => (
    <CopyProjectChildrenOverlay
      {...useCopyProjectChildrenOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    COPY_PROJECT_CHILDREN_OVERLAY: CopyProjectChildrenOverlayPayload
  }
}
